var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"iv2__host-name d-none d-xl-block position-absolute"},[_c('p',{staticClass:"size-12 m-0 text-center font-speedee"},[_vm._v(_vm._s(_vm.hostname))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }